import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { applicationPaths, checkInKeys, localStorageKeys } from '../../../../Models/configurations';
import { CheckInDataService } from './../../../../Services/check-in-data.service';
import { CustomerService } from './../../../../Services/customer.service';
import { SecureStorageService } from './../../../../Services/secure-storage.service';
import { UtilityServices } from './../../../../Services/utility.services';
import { Application, FeatureCode } from './../../../../../../../Autofacets-Core/src/app/utils/enums';
import { CallDealerLogEntryRequestModel } from './../../../../Models/call-dealer-log-entry-requestModel'
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-seven-step',
  templateUrl: './seven-step.component.html',
  styleUrls: ['./seven-step.component.css']
})
export class SevenStepComponent implements OnInit {
  private params: any;
  dealerPhone: any;
  checkInDateTime: any;
  additionalDetail: any;
  itemId: any;
  itemValue: any;
  serviceData:any;
  offerDetails: any;
  notification: any;
  showStatusTracker = false;
  statusTrackerLink : string = null;
  notificationparams: any;
  dealerDetail: any;
  notifyUser: any;
  language:any;
  selectedLangExpireDate = new Date();
  isDisplayCheckInNotAllowed:boolean=false;
  isMapDirection:boolean = true
  mapDirectionLink:string = ''
  errorMessage:string

  constructor(
    private readonly utilityService: UtilityServices,
    private readonly customerService: CustomerService,
    private readonly checkInDataService: CheckInDataService,
    private readonly cookieService:CookieService,
    private readonly secureStorageService: SecureStorageService,
    private spinner: NgxSpinnerService,
    private readonly dateTimePipe: DatePipe,
    private currentLng:CurrentLanguage,
    private readonly toaster: ToastrService,
    private readonly translate: TranslateService
  ) {
    this.showStatusTracker = false;
  }

  public moveNext(): void {
    this.utilityService.navigateToNext('/' + applicationPaths.calldealer);
    this.additionalDetail = '';
    this.offerDetails = false;
  }

  private parametersCollection() {
    const data = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    this.dealerDetail = data.dealerDetail;
    this.dealerPhone = this.dealerDetail.landlineNumber;
    this.checkInDateTime = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).checkInDate;

    if (typeof (this.secureStorageService.getKeyData(localStorageKeys.additionalDetails)) !== 'undefined') {
      this.additionalDetail = this.secureStorageService.getKeyData(localStorageKeys.additionalDetails).additionalDetail;
    }

    if (typeof (this.secureStorageService.getKeyData(localStorageKeys.serviceDetails)) !== 'undefined') {
      this.itemId = this.secureStorageService.getKeyData(localStorageKeys.serviceDetails).itemIds;
    } else {
      this.itemId = [];
    }
    if (typeof (this.secureStorageService.getKeyData(localStorageKeys.serviceDetails)) !== 'undefined') {
      this.itemValue = this.secureStorageService.getKeyData(localStorageKeys.serviceDetails).itemValues;
    } else {
      this.itemValue = [];
    }

    if (typeof (this.secureStorageService.getKeyData(localStorageKeys.serviceDetails)) !== 'undefined') {
      this.serviceData = this.secureStorageService.getKeyData(localStorageKeys.serviceDetails).serviceDetails;
    } else {
      this.serviceData = [];
    }
    if (typeof (this.secureStorageService.getKeyData(localStorageKeys.offerValueDetails)) !== 'undefined') {
      this.offerDetails = true;
    } else {
      this.offerDetails = false;
    }
    if (typeof (this.secureStorageService.getKeyData(localStorageKeys.notifyUserDetails)) !== 'undefined') {
      this.notifyUser = this.secureStorageService.getKeyData(localStorageKeys.notifyUserDetails).notifyUser;
    } else {
      this.notifyUser = false;
    }
  }

  async getAppointmentCheckInStatus(){
    await this.customerService.GetAppointmentCheckInStatus().subscribe(res => {
      if(res.isSuccess){
        this.appointmentConfirmation();
      }
      else{
        this.isDisplayCheckInNotAllowed = true;
        this.errorMessage = res.resultMessage;
        this.toaster.warning(this.translate.instant(this.errorMessage));
        this.spinner.hide();
      }
    })
  } 

  private appointmentConfirmation() {
    this.spinner.show();
    this.params = {
      CheckInDetail: {
        CheckInDateTime: this.checkInDateTime,
        EmailId: this.secureStorageService.getKeyData(localStorageKeys.ownerDetails)?.email,
        MobileNo: this.secureStorageService.getKeyData(localStorageKeys.ownerDetails)?.phoneNumber,
        GdprConsent: this.secureStorageService.getKeyData(localStorageKeys.privacyConsent)?.userPrivacyAccept,
        AdditionalRepairInfo: this.additionalDetail,
        CheckInMileageUnit: this.secureStorageService.getKeyData(localStorageKeys.checkingModule)?.vehicleDetail.checkInMileageUnit,
        CheckInMileageValue: this.secureStorageService.getKeyData(localStorageKeys.checkingModule)?.vehicleDetail.checkInMileageValue,
      },
      CustomerAdvice: {
        ItemIds: this.itemId,
        ItemValues: this.itemValue,
        Service: this.serviceData
      },
      CustomerContact: {
        ContactUser: this.offerDetails,
        notifyUser: this.notifyUser,
        offerService: this.offerDetails
      },
      NomineeDetails:{
        Address: this.secureStorageService.getKeyData(localStorageKeys.nomineeContactDetails)?.address1 + ' ' + this.secureStorageService.getKeyData(localStorageKeys.nomineeContactDetails)?.address2,
        City: this.secureStorageService.getKeyData(localStorageKeys.nomineeContactDetails)?.city,
        Country: this.secureStorageService.getKeyData(localStorageKeys.nomineeContactDetails)?.country,
        Email: this.secureStorageService.getKeyData(localStorageKeys.nomineeContactDetails)?.email,
        PostCode: this.secureStorageService.getKeyData(localStorageKeys.nomineeContactDetails)?.postcode,
        IsOwner:this.secureStorageService.getKeyData(localStorageKeys.checkingModule)?.IsOwner,
        Name:this.secureStorageService.getKeyData(localStorageKeys.nomineeContactDetails)?.name,
        PhoneNo:this.secureStorageService.getKeyData(localStorageKeys.nomineeContactDetails)?.phoneNumber,
        PhoneCode:this.secureStorageService.getKeyData(localStorageKeys.nomineeContactDetails)?.countryPhoneCode,
      }
    };
    this.customerService.UpdateCustomerCheckInDetails(this.params)
      .subscribe(
        res => {
            const data = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
            if (data.checkInStatus !== true) {
              data.checkInStatus = true;
              this.secureStorageService.setKeyData(localStorageKeys.checkingModule, data);
            }
            this.redirectToStatuTracker();
          this.spinner.hide();
        },
        err => {
          this.notification = 'Something Went Wrong, Plese try again.';
          this.spinner.hide();
        },
        () => {
          this.spinner.hide();
        }
      );
  }

  public async stepInitializer() {
    this.spinner.show();
    if (!this.secureStorageService.getKeyData(localStorageKeys.checkingModule).checkInStatus &&
    !this.secureStorageService.getKeyData('_CheckinModuleData').IsCheckInNotAllowed) {
      this.parametersCollection();
      await this.getAppointmentCheckInStatus();
    } else {
      this.spinner.hide();
      this.parametersCollection();
      this.redirectToStatuTracker();
    }
  }

  CallDealerLogEntry(){
     let request:CallDealerLogEntryRequestModel ={
       dealerPhone:this.dealerPhone
     }
     this.checkInDataService.callDealerLogEntry(request).subscribe();
  }

  public getParameterByName(result: any) {
    const url = result.repairStatusTinyUrl;
    // tslint:disable-next-line: one-variable-per-declaration
    const regex = /[?&=](([^&#]*)|&|#|$)/, results = regex.exec(url);
    if (!results) { return null; }
    if (!results[2]) { return ''; }
    return '?' + results[2];
  }

  public redirectToStatuTracker() {
    this.language = this.cookieService.get('userSelectedLanguage');
    this.isDisplayCheckInNotAllowed=this.secureStorageService.getKeyData(localStorageKeys.isCheckInNotAllowed)===1 ? true :false;
    if(this.isDisplayCheckInNotAllowed)
    {
    this.checkInDataService.GetStatusTrackerTinyUrl()
      .subscribe(
        res => {
          if (res['shortUrl'] !== null) {
            this.statusTrackerLink = res['shortUrl']; 
            this.showStatusTracker = true;
          } else {
            this.showStatusTracker = false;
          }
          this.spinner.hide();
        },
        _err => {
          this.spinner.hide();
        },
        () => {
          this.spinner.hide();
        }
      );
    }
  }


  ngOnInit(): void {
    this.stepInitializer();
    this.selectedLangExpireDate.setDate(this.selectedLangExpireDate.getDate() + 1);
    let data = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    this.dealerDetail = data.dealerDetail;
    this.checkInDateTime = data.checkInDate ? data.checkInDate : new Date();
    this.currentLng.featureList.subscribe((response) => {
      if(response?.length > 0){
        this.isMapDirection = response.find(x=>x.featureCode === FeatureCode.MapDirection)?.isActive
        if(this.isMapDirection){
          const plateform = Utility.detectDevicePlatform();
          let link = response.find(x=>x.featureCode === FeatureCode.MapDirection)?.serviceUrl1;
          if (plateform == 'ios') {
            link = response.find(x=>x.featureCode === FeatureCode.MapDirection)?.serviceUrl2;
          }
          this.mapDirectionLink = link + Utility.getDirectionAddress(data.dealerDetail);
        }
        else{
          this.isMapDirection = false;
        }
      }
    });
  }
  openMapDirection() {
    const address = this.mapDirectionLink.split('daddr=')[1];
    const encodedAddr = encodeURIComponent(address);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const origin = `${position.coords.latitude},${position.coords.longitude}`;
          this.launchDirections(encodedAddr, encodeURIComponent(origin));
        },
        () => {
          this.launchDirections(encodedAddr, '');
        }
      );
    } else {
      this.launchDirections(encodedAddr, '');
    }
  }

  private launchDirections(encodedAddr: string, encodedOrigin: string) {
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      window.location.href = `comgooglemaps://?saddr=${encodedOrigin}&daddr=${encodedAddr}`;
      setTimeout(() => !document.hidden && (window.location.href = `maps://?saddr=${encodedOrigin}&daddr=${encodedAddr}`), 500);
      setTimeout(() => !document.hidden && window.open(`https://www.google.com/maps/dir/?api=1&origin=${encodedOrigin}&destination=${encodedAddr}`, '_blank'), 1000);
    } else {
      window.open(`https://www.google.com/maps/dir/?api=1&origin=${encodedOrigin}&destination=${encodedAddr}`, '_blank');
    }
  }
  
}
